import React, { useRef, useEffect } from "react";
import TextEditor from "../Elements/TextEditor";
import { Button } from "../Elements";
import { useState } from "react";
import { toast } from "react-toastify";
import commonNetwork from "../../../common/api/commonNetwork";
import { getContracts } from "../../../store/slices/contractsSlice";
import { useDispatch } from "react-redux";

export default function Contracts({contracts}) {
  const dispatch= useDispatch();
  const contractInfoRef = useRef();
  const serviceContRef = useRef();
  const distanceSalesContRef = useRef();
  const securityInfoRef = useRef();
  const refInfoRef = useRef();
  const kvkkTextRef = useRef();
  const [openTab, setOpenTab] = React.useState(1);
  const [contractsState, setContractsState] = useState({
    contactAgreement: contracts.contactAgreement,
    serviceContracts: contracts.serviceContracts,
    distanceSalesContracts:contracts.distanceSalesContracts,
    securityInfo: contracts.securityInfo,
    refundInfo: contracts.refundInfo,
    kvkkText: contracts.kvkkText,
  });
  const [isloadingContracts,setIsloadingContracts] = useState();

  useEffect(() => {
    fetchParameterData();
  }, []);
 
  const fetchParameterData = async () => {
      contractInfoRef.current.setEditorValue(contracts?.contactAgreement);
      serviceContRef.current.setEditorValue(contracts?.serviceContracts);
      distanceSalesContRef.current.setEditorValue(contracts?.distanceSalesContracts);
      securityInfoRef.current.setEditorValue(contracts?.securityInfo);
      refInfoRef.current.setEditorValue(contracts?.refundInfo);
      kvkkTextRef.current.setEditorValue(contracts?.kvkkText);
  };
 
  const onSubmit = async () => {
    const params = {
      contactAgreement: contractsState.contactAgreement,
      serviceContracts: contractsState.serviceContracts,
      distanceSalesContracts: contractsState.distanceSalesContracts,
      securityInfo: contractsState.securityInfo,
      refundInfo: contractsState.refundInfo,
      kvkkText: contractsState.kvkkText,
    };

  
    const response = await commonNetwork.post(
      "/parameters/saveAgreements",
      params
    );

    if (response.isSuccess) {
      dispatch(getContracts());
      toast.success("Kayıt işlemi başarılı");
    } else {
      toast.error("Kayıt işlemi başarısız");
    }
    setIsloadingContracts(false);
  };
  return (
    <div>
      <div className="px-4  py-2  bg-white shadow-md space-y-4  mt-2 rounded-md">
        <div className="my-1">
          <h1 className="px-4 font-bold text-contrast-90">Sözleşmeler</h1>
          <div className="pt-2 mt-3">
            <hr></hr>
            <div>
              <div className="flex flex-wrap">
                <div className="w-full">
                  <ul
                    className="flex mb-0 list-none flex-wrap  pb-4 flex-row  "
                    role="tablist"
                  >
                    <li className="-mb-px  last:mr-0 lg:flex-auto text-center text-2xs md:basis-1/3 sm:basis-1/3 basis-1/2">
                      <a
                        className={
                          "text-2xs font-bold uppercase px-1 py-3 shadow-lg rounded block leading-normal " +
                          (openTab === 1
                            ? "text-blue-500 bg-gray-200"
                            : "text-gray-700 bg-white")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(1);
                        }}
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                      >
                        İLETİŞİM BİLGİLERİ
                      </a>
                    </li>
                    <li className="-mb-px  last:mr-0 lg:flex-auto text-center text-2xs md:basis-1/3 sm:basis-1/3 basis-1/2">
                      <a
                        className={
                          "text-2xs font-bold uppercase px-1 py-3 shadow-lg rounded block leading-normal " +
                          (openTab === 2
                            ? "text-blue-500 bg-gray-200"
                            : "text-gray-700 bg-white")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(2);
                        }}
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                      >
                        HİZMET SÖZLEŞMESİ
                      </a>
                    </li>
                    <li className="-mb-px  last:mr-0 lg:flex-auto text-center text-2xs md:basis-1/3 sm:basis-1/3 basis-1/2">
                      <a
                        className={
                          "text-2xs font-bold uppercase px-1 py-3 shadow-lg rounded block leading-normal " +
                          (openTab === 3
                            ? "text-blue-500 bg-gray-200"
                            : "text-gray-700 bg-white")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(3);
                        }}
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                      >
                        MESAFELİ SATIŞ SÖZLEŞMESİ
                      </a>
                    </li>
                    <li className="-mb-px  last:mr-0 lg:flex-auto text-center text-2xs md:basis-1/3 sm:basis-1/3 basis-1/2">
                      <a
                        className={
                          "text-2xs font-bold uppercase px-1 py-3 shadow-lg rounded block leading-normal " +
                          (openTab === 4
                            ? "text-blue-500 bg-gray-200"
                            : "text-gray-700 bg-white")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(4);
                        }}
                        data-toggle="tab"
                        href="#link1"
                        role="tablist"
                      >
                        GÜVENLİK BİLGİLERİ
                      </a>
                    </li>
                    <li className="-mb-px  last:mr-0 lg:flex-auto text-center text-2xs md:basis-1/3 sm:basis-1/3 basis-1/2">
                      <a
                        className={
                          "text-2xs font-bold uppercase px-1 py-3 shadow-lg rounded block leading-normal " +
                          (openTab === 5
                            ? "text-blue-500 bg-gray-200"
                            : "text-gray-700 bg-white")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(5);
                        }}
                        data-toggle="tab"
                        href="#link2"
                        role="tablist"
                      >
                        İADE BİLGİLERİ
                      </a>
                    </li>
                    <li className="-mb-px  last:mr-0 lg:flex-auto text-center text-2xs md:basis-1/3 sm:basis-1/3 basis-1/2">
                      <a
                        className={
                          "text-2xs font-bold uppercase px-1 py-3 shadow-lg rounded block leading-normal " +
                          (openTab === 6
                            ? "text-blue-500 bg-gray-200"
                            : "text-gray-700 bg-white")
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          setOpenTab(6);
                        }}
                        data-toggle="tab"
                        href="#link3"
                        role="tablist"
                      >
                        KVKK AYDINLATMA METNİ
                      </a>
                    </li>
                  </ul>
                  <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded">
                    <div className="px-4 py-2 flex-auto">
                      <div className="tab-content tab-space">
                        <div
                          className={openTab === 1 ? "block" : "hidden"}
                          id="link1"
                        >
                          <div className=" flex justify-center ">
                            <TextEditor
                              ref={contractInfoRef}
                              onChangeText={(text) => {
                                setContractsState({
                                  ...contractsState,
                                  contactAgreement: text,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={openTab === 2 ? "block" : "hidden"}
                          id="link2"
                        >
                          <div className=" flex justify-center ">
                            <TextEditor
                              ref={serviceContRef}
                              onChangeText={(text) => {
                                setContractsState({
                                  ...contractsState,
                                  serviceContracts: text,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={openTab === 3 ? "block" : "hidden"}
                          id="link3"
                        >
                          <div className=" flex justify-center ">
                            <TextEditor
                              ref={distanceSalesContRef}
                              onChangeText={(text) => {
                                setContractsState({
                                  ...contractsState,
                                  distanceSalesContracts: text,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={openTab === 4 ? "block" : "hidden"}
                          id="link4"
                        >
                          <div className=" flex justify-center ">
                            <TextEditor
                              ref={securityInfoRef}
                              onChangeText={(text) => {
                                setContractsState({
                                  ...contractsState,
                                  securityInfo: text,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={openTab === 5 ? "block" : "hidden"}
                          id="link5"
                        >
                          <div className=" flex justify-center ">
                            <TextEditor
                              ref={refInfoRef}
                              onChangeText={(text) => {
                                setContractsState({
                                  ...contractsState,
                                  refundInfo: text,
                                });
                              }}
                            />
                          </div>
                        </div>
                        <div
                          className={openTab === 6 ? "block" : "hidden"}
                          id="link6"
                        >
                          <div className=" flex justify-center ">
                            <TextEditor
                              ref={kvkkTextRef}
                              onChangeText={(text) => {
                                setContractsState({
                                  ...contractsState,
                                  kvkkText: text,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="px-4  w-full justify-end flex flex-row">
            <Button
              callback={(e) => {
                onSubmit();
                setIsloadingContracts(true);
              }}
              type="button"
              hover="primary"
              color="primary"
              loading={isloadingContracts}
            >
              Kaydet
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
